import { Spin } from 'antd';
import React from 'react';

import styles from './Spinner.module.less';

const Spinner: React.FC = () => {
  return (
    <div className={styles.spinnerWrapper}>
      <Spin size="large" />
    </div>
  );
};

export default Spinner;
